import axios from "../../lib/axiosInstance";

export function addLanguagesToUser(payload, targetUserId) {
  return axios
    .post("language", payload, { params: targetUserId ? { targetUserId } : undefined })
    .then((res) => res.data);
}

export function fetchAllUserLanguages(payload) {
  const params = payload ? { ...payload } : undefined;

  return axios.get("language", { params }).then((res) => res.data);
}

export function deleteUserLanguage(id, targetUserId) {
  return axios
    .delete(`language/${id}`, { params: targetUserId ? { targetUserId } : undefined })
    .then((res) => res.data);
}
